"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = exports.TwsDropdownMenu = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
exports.TwsDropdownMenu = styled_components_1.default.div.attrs({
    className: 'tws-dropdown-menu',
    role: 'menu',
    'data-testid': 'tws-dropdown-menu',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tz-index: 1001;\n\tposition: absolute;\n\ttop: ", ";\n\tleft: ", ";\n\tdisplay: ", ";\n\tborder-radius: ", ";\n\tbox-shadow: ", ";\n\toutline: none;\n\tbackground-color: ", ";\n\twidth: 200px;\n\ttext-align: left;\n\t& > div:first-child {\n\t\tborder-top-right-radius: 3px;\n\t\tborder-top-left-radius: 3px;\n\t}\n\t& > div:last-child {\n\t\tborder-bottom-right-radius: 3px;\n\t\tborder-bottom-left-radius: 3px;\n\t}\n"], ["\n\tz-index: 1001;\n\tposition: absolute;\n\ttop: ", ";\n\tleft: ", ";\n\tdisplay: ", ";\n\tborder-radius: ", ";\n\tbox-shadow: ", ";\n\toutline: none;\n\tbackground-color: ", ";\n\twidth: 200px;\n\ttext-align: left;\n\t& > div:first-child {\n\t\tborder-top-right-radius: 3px;\n\t\tborder-top-left-radius: 3px;\n\t}\n\t& > div:last-child {\n\t\tborder-bottom-right-radius: 3px;\n\t\tborder-bottom-left-radius: 3px;\n\t}\n"])), function (props) { return "".concat(props.y || 30, "px"); }, function (props) { return "".concat(props.x || 0, "px"); }, function (props) { return (props.open ? 'block' : 'none'); }, globalVars_module_scss_1.default.borderRadius3, globalVars_module_scss_1.default.shadow2, globalVars_module_scss_1.default.white);
exports.TwsDropdownMenu.displayName = 'TwsDropdownMenu';
var DropdownMenu = /** @class */ (function (_super) {
    __extends(DropdownMenu, _super);
    function DropdownMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.handleOnClose = _this.handleOnClose.bind(_this);
        _this.dropdownMenuRef = React.createRef();
        return _this;
    }
    DropdownMenu.prototype.UNSAFE_componentWillUpdate = function (nextProps) {
        var _this = this;
        if (this.dropdownMenuRef && this.dropdownMenuRef.current && nextProps.open) {
            this.focusTimer = setTimeout(function () {
                var _a;
                // Based on actual test failures, it's still possible that the ref will be undefined.
                (_a = _this.dropdownMenuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
        }
    };
    DropdownMenu.prototype.render = function () {
        var _this = this;
        var children = React.Children.map(this.props.children, function (child) {
            if (child) {
                return React.cloneElement(child, __assign({ onClose: _this.handleOnClose }, child.props));
            }
            return null;
        });
        return (React.createElement(exports.TwsDropdownMenu, __assign({ ref: this.dropdownMenuRef }, this.props, { tabIndex: 2, onBlur: this.handleOnBlur }), children));
    };
    DropdownMenu.prototype.handleOnClose = function () {
        var onClose = this.props.onClose;
        if (onClose) {
            onClose();
        }
    };
    DropdownMenu.prototype.handleOnBlur = function () {
        var _a = this.props, hideOnBlur = _a.hideOnBlur, onBlur = _a.onBlur;
        if (hideOnBlur && onBlur) {
            onBlur();
        }
    };
    DropdownMenu.defaultProps = {
        hideOnBlur: true,
    };
    return DropdownMenu;
}(React.Component));
exports.DropdownMenu = DropdownMenu;
var templateObject_1;
